import Image from "next/image";

export default function AboutUs({ company }) {
    return (
        <>
            <div className="">
                <div className="h3-about-section col-lg-12 px-4">
                    <div className="flex-column align-items-start">
                        <h1 className="font-size-60 white col-lg-4 col-md-6 box-text-title">Saiba mais sobre o <span className="color-primary">{company.nickName}!</span></h1>
                        {
                            company.about
                                ? company.about.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                    return <p className="mb-0 col-lg-6 col-md-8 white" style={{ textAlign: "justify", fontSize: "18px" }} key={key}>{item}<br /></p>
                                })
                                : ''
                        }
                        <a href="/contato" className="mt-3">
                            <div className="btn btn-secondary btn-transparent btn-md d-block btn-black col-lg-6" style={{ marginBottom: "10px" }}>
                                <i></i>
                                <span className="white">FALE COM NOSSA EQUIPE</span>
                            </div>

                        </a>
                    </div>
                </div>

                <div className="box-values">

                    <div className="values">
                        <span class="corner-left"></span>
                        <span class="corner-right"></span>

                        <div className="values-title">
                            <div>
                                <Image className="icons-about-us" src={'/img/icons/missao.png'} alt="compromisso" width={40} height={40} />
                            </div>
                            <h4>Nossa Missão</h4>
                        </div>
                        <div className="values-content">
                            {
                                company.mission
                                    ? company.mission.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                        return <p className="mb-0" style={{ textAlign: "justify", fontSize: "18px" }} key={key}>{item}<br /></p>
                                    })
                                    : ''
                            }
                        </div>
                    </div>

                    <div className="values">
                        <span class="corner-left"></span>
                        <span class="corner-right"></span>

                        <div className="values-title">
                            <div>
                                <Image className="icons-about-us" src={'/img/icons/visao.png'} alt="visão" width={40} height={40} />
                            </div>
                            <h4>Nossa Visão</h4>
                        </div>
                        <div className="values-content">
                            {
                                company.vision
                                    ? company.vision.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                        return <p className="mb-0" style={{ textAlign: "justify", fontSize: "18px" }} key={key}>{item}<br /></p>
                                    })
                                    : ''
                            }
                        </div>
                    </div>

                    <div className="values">
                        <span class="corner-left"></span>
                        <span class="corner-right"></span>

                        <div className="values-title">
                            <div>
                                <Image className="icons-about-us" src={'/img/icons/valores.png'} alt="valores" width={40} height={40} />
                            </div>
                            <h4>Nossos Valores</h4>
                        </div>
                        <div className="values-content">
                            {
                                company.values
                                    ? company.values.replaceAll('<br>', '\n').replaceAll(/(<([^>]+)>)/ig, '').split('\n').map((item, key) => {
                                        return <p className="mb-0" style={{ textAlign: "justify", fontSize: "18px" }} key={key}>{item}<br /></p>
                                    })
                                    : ''
                            }
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}